@if (loaded()) {
  @switch (toolbarPosition()) {
    @case (ToolbarPosition.Top) {
      <lfw-topbar-navigation>
        <router-outlet />
      </lfw-topbar-navigation>
    }
    @case (ToolbarPosition.Left) {
      <lfw-sidebar-navigation>
        <router-outlet />
      </lfw-sidebar-navigation>
    }
    @case (ToolbarPosition.Bottom) {
      <lfw-bottom-navigation>
        <router-outlet />
      </lfw-bottom-navigation>
    }
  }
}
